import React from "react";
import "./SuccessMessage.scss";
import parse from "html-react-parser";

import { useTranslation } from "react-i18next";
import { FaCheck } from "react-icons/fa6";
const SuccessMessage = ({ title, email }) => {
  const { t } = useTranslation();
  return (
    <div id='SuccessMessage'>
      <div className='SuccesBox'>
        <div className='icon'>
          <FaCheck />
        </div>
        <div className='title'>{title}</div>
        <div className='text'>
          {parse(
            t(
              "landing.accessLoadboard.Access link sent to <span>{{email}}</span> Check your inbox to proceed.",
              {
                email: email,
              }
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessMessage;
